<div class="share-button">
  <mat-icon *ngIf="!copied" [svgIcon]="svgIcon" (click)="shareButtonClicked(buttonType)"></mat-icon>
  <mat-icon *ngIf="copied" class="check-icon">check</mat-icon>
</div>
